import React from "react";
import EmployeeForm from "../../components/features/employees/EmployeeForm";

const CreateEmployeePage = () => {
  return <EmployeeForm editMode={false} />;
};

export default CreateEmployeePage;
